import React, { Component } from "react";
import { connect } from "react-redux";
import Filter from "../components/Filter";
import { changeSubfilterValues, fetchData } from "../actions/stats";
import PropTypes from "prop-types";

const mapStateToProps = (state, ownProps) => {
  const stats = state.stats || {};
  const filters = stats.filters;
  const filtersData = filters || {};
  const filterData = filtersData[ownProps.filter.id] || {};

  const filterConfig = ownProps.filter || {};
  return {
    loading: stats.subfilterLoading && ownProps.filter.id === stats.subfilterSelected,
    values: filterData.values || filterConfig.defaultValue || [],
    data: filterData.data || [],
    dataSelected: filterData.dataSelected || [],
    input: filterData.input || "",
    target: filterData.target || "",
    loaded: !!filterData.data
  };
};

class FilterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onFocus() {
    const { fetchData, filter, loaded } = this.props;
    console.log("fetch ?", loaded, filter.data, !loaded && !filter.data)
    if (!loaded && !filter.data) {
      fetchData(filter.id);
    }
  }

  render() {
    const { filter = {}, kpi, values, loading, data, dataSelected, ...others } = this.props;
    const disabled = filter.hasOwnProperty("active") && !filter.active;

    return (
      <div>
        <Filter
          id={filter.id}
          kpi={kpi}
          label_mapping={filter.label_mapping}
          value={values}
          loading={loading}
          dataSelected={dataSelected}
          data={filter.data || data}
          placeholder={filter.label}
          onFocus={() => {
            this.onFocus();
          }}
          onChange={values => {
            if (!Array.isArray(values)) {
              values = [values];
            }
            this.props.changeSubfilterValues(filter.id, values);
          }}
          type={filter.type}
          mode={filter.mode}
          disabled={disabled}
          maxTagCount={filter.maxTagCount || 0}
          defaultValue={filter.defaultValue}
          allowClear={filter.hasOwnProperty("allowClear") ? filter.allowClear : true}
          {...others}
        />
      </div>
    );
  }
}

Filter.propTypes = {
  filter: PropTypes.any.isRequired,
  kpi: PropTypes.any
};

export default connect(
  mapStateToProps,
  { fetchData, changeSubfilterValues }
)(FilterContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/FilterContainer.js